import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, Link, Typography, Divider } from "@material-ui/core";
import { FaFacebookSquare } from "react-icons/fa";
import { ImInstagram } from "react-icons/im";
import { IoLogoYoutube } from "react-icons/io";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "auto",
    background: "linear-gradient(135deg, #b01200 0%, #6e0000 100%)",
    zIndex: 10,
    bottom: 0,
    right: 0,
    left: 0,
    paddingLeft: "11%",
    paddingRight: "11%",
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    [theme.breakpoints.down("sm")]: {
      paddingLeft: "5%",
      paddingRight: "5%",
    },
  },
  linksRow: {
    flexWrap: "wrap",
    gap: theme.spacing(0.5),
  },
  containerLink: {
    paddingRight: theme.spacing(3),
    paddingBottom: theme.spacing(0.75),
    [theme.breakpoints.down("xs")]: {
      paddingRight: theme.spacing(1.5),
    },
  },
  link: {
    position: "relative",
    textDecoration: "none",
    fontSize: 13,
    fontFamily: "PT Sans Narrow, sans-serif",
    color: "rgba(255, 255, 255, 0.82)",
    fontWeight: 400,
    letterSpacing: "0.05em",
    textTransform: "uppercase",
    transition: "color 0.2s ease",
    "&::after": {
      content: '""',
      position: "absolute",
      bottom: -2,
      left: 0,
      width: "0%",
      height: "1px",
      background: "rgba(255, 255, 255, 0.9)",
      transition: "width 0.25s ease",
    },
    "&:hover": {
      color: "white",
      "&::after": {
        width: "100%",
      },
    },
    [theme.breakpoints.down("xs")]: {
      fontSize: 11,
    },
  },
  divider: {
    backgroundColor: "rgba(255, 255, 255, 0.15)",
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
  },
  bottomRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(1),
  },
  copyright: {
    color: "rgba(255, 255, 255, 0.55)",
    fontSize: 11,
    fontFamily: "PT Sans Narrow, sans-serif",
    letterSpacing: "0.03em",
    lineHeight: 1.6,
    [theme.breakpoints.down("xs")]: {
      fontSize: 10,
    },
  },
  copyrightLink: {
    color: "rgba(255, 255, 255, 0.7)",
    textDecoration: "none",
    borderBottom: "1px solid rgba(255, 255, 255, 0.3)",
    transition: "color 0.2s ease, border-color 0.2s ease",
    "&:hover": {
      color: "white",
      borderBottomColor: "white",
    },
  },
  socialRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },
  socialIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    borderRadius: "50%",
    color: "rgba(255, 255, 255, 0.8)",
    background: "rgba(255, 255, 255, 0.08)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    transition: "all 0.25s ease",
    textDecoration: "none",
    "&:hover": {
      color: "white",
      background: "rgba(255, 255, 255, 0.18)",
      borderColor: "rgba(255, 255, 255, 0.4)",
      transform: "translateY(-2px)",
    },
  },
}));

export default function LabelBottomNavigation() {
  const classes = useStyles();
  const { t } = useTranslation();

  const links = [
    { labelKey: "footer.privacy_policy", hrefKey: "footer.link_privacy_policy" },
    { labelKey: "footer.cookies_policy", hrefKey: "footer.link_cookies_policy" },
    { labelKey: "footer.certification", hrefKey: "footer.link_certification" },
    { labelKey: "footer.company_policy", hrefKey: "footer.link_company_policy" },
    { labelKey: "footer.condition", hrefKey: "footer.link_condition" },
    { labelKey: "footer.sales_contract", hrefKey: "footer.link_sales_contract" },
    { labelKey: "footer.return_policy", hrefKey: "footer.link_return_policy" },
  ];

  return (
    <Grid container className={classes.root}>
      <Grid container item xs={12} className={classes.linksRow}>
        {links.map(({ labelKey, hrefKey }) => (
          <Grid item key={labelKey} className={classes.containerLink}>
            <Link href={t(hrefKey)} className={classes.link} target="_blank">
              {t(labelKey)}
            </Link>
          </Grid>
        ))}
      </Grid>

      <Grid item xs={12}>
        <Divider className={classes.divider} />
      </Grid>

      <Grid item xs={12} className={classes.bottomRow}>
        <Typography className={classes.copyright}>
          {"© ECAT s.r.l. — Via Bologna 5, 12084, Mondovì (CN) — P.I. 00206980047 — REA CN-87414 — capitale sociale 160.000 € | Powered by "}
          <Link
            href="https://www.yoursystem.it/"
            className={classes.copyrightLink}
            target="_blank"
          >
            Yoursystem
          </Link>
        </Typography>

        <div className={classes.socialRow}>
          <Link
            href="https://www.facebook.com/EcatOrologiCampane/"
            className={classes.socialIcon}
            target="_blank"
          >
            <FaFacebookSquare size={16} />
          </Link>
          <Link
            href="https://www.youtube.com/channel/UCosePA7v65wsJ_jANws53pA"
            className={classes.socialIcon}
            target="_blank"
          >
            <IoLogoYoutube size={17} />
          </Link>
          <Link
            href="https://www.instagram.com/ecatorologiecampane/"
            className={classes.socialIcon}
            target="_blank"
          >
            <ImInstagram size={15} />
          </Link>
        </div>
      </Grid>
    </Grid>
  );
}
